export const CHAT_INTENTS_SHOW_SUGGESTIONS = new Set([
  'SMALL_TALK',
  'OUT_OF_SCOPE',
  'LIST_MY_ASSETS',
])

export interface SuggestedQuery {
  label: string
  message: string
}

export const CHAT_SUGGESTED_QUERIES: SuggestedQuery[] = [
  {
    label: 'Asset overview',
    message: 'Give me a health overview of my assets.',
  },
  {
    label: 'Needs attention this week',
    message: 'Which assets need attention this week?',
  },
  {
    label: 'Why is an asset yellow or red?',
    message: 'Why are my yellow or red assets flagged?',
  },
  {
    label: 'Open issues',
    message: 'Show me all open issues.',
  },
  {
    label: 'Uptime this month',
    message: 'What is the uptime of my assets this month?',
  },
  {
    label: 'Energy: last week vs this week',
    message: 'Compare energy consumption for last week and this week.',
  },
  {
    label: 'Room temp & humidity',
    message: 'What are the latest room temperature and humidity readings?',
  },
  {
    label: 'Overamping',
    message: 'Which assets were overamping in the last 7 days?',
  },
  {
    label: 'Generator run time',
    message: 'What was the generator run time last month?',
  },
  {
    label: 'Outside weather',
    message: 'What is the outside temperature and humidity right now?',
  },
  {
    label: 'List my assets',
    message: 'List my assets',
  },
]

export const CHAT_POST_LIST_SUGGESTED_QUERIES: SuggestedQuery[] =
  CHAT_SUGGESTED_QUERIES.filter((s) => s.label !== 'List my assets')
